import "./experience.scss";
import ExperienceBlock from "./experience-block";
import experiencesData from "../../assets/data/experiences.json";

const Experience = () => {
  const { experiences } = experiencesData;

  return (
    <div className="o-experience">
      <div className="o-experience__content">
        <h2 className="o-experience__content__name">#Work Experiences</h2>
        <div className="o-experience__content__items">
          {experiences.map((experience, index) => (
            <ExperienceBlock experience={experience} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
